// extracted by mini-css-extract-plugin
module.exports = {"search-box":"T_fX","search-box__input":"T_fY form-control","search-box__icon":"T_fZ ml-2"};